const vwapCalc = (amount: string = '0', orderbook: any = { buy: [], sell: [] }, tradeSide: string = 'sell') => {
  if (!orderbook.buy.length || !orderbook.sell.length || amount === '0') return 0;

  const orderbookOrders = tradeSide === 'sell' ? [...orderbook['buy']] : [...orderbook['sell']];
  let newAmount = Number(amount);
  let newOrderbook = [];

  // Take orders from orderbook to fill current amount
  for (let i = 0; i <= orderbookOrders.length - 1; i++) {
    if (orderbookOrders[i].quantity < newAmount) {
      newOrderbook.push(orderbookOrders[i]);
      newAmount -= orderbookOrders[i].quantity;
    } else {
      newOrderbook.push({
        quantity: newAmount,
        price: orderbookOrders[i].price,
      });
      break;
    }
  }

  let calc1 = 0;
  let calc2 = 0;

  // Cacl VWAP by formula ([0]price * [0]quantity + [1]price * [1]quantity) / [0]quantity + [1]quantity
  for (let i = 0; i <= newOrderbook.length - 1; i++) {
    calc1 += newOrderbook[i].price * newOrderbook[i].quantity;
    calc2 += newOrderbook[i].quantity;
  }

  return calc1 / calc2;
};

export default vwapCalc;
